import {AxiosResponse} from "axios"
import {PagedData} from "@/services/models/shared/PagedData";
import BimsHttpService from "@/services/BimsHttpService";
import FileProvider from "@/utilities/providers/FileProvider";
import {
  ComputerAssetsFilterOptions,
  ComputerAsset,
  NewComputerAsset,
  UpdateComputerAsset
} from "@/services/models/ComputerAsset";
import {
  ComputerLeasesFilterOptions,
  ComputerLease,
  NewComputerLease,
  UpdateComputerLease
} from "@/services/models/ComputerLease";

class ComputersService {
  /**
   * @description Returns a paged list of computer assets
   */
  getComputerAssets(filter: ComputerAssetsFilterOptions
  ): Promise<PagedData<ComputerAsset>> {
      return BimsHttpService.get(`/computers/assets`, {
          params: filter
      }).then((response: AxiosResponse<PagedData<ComputerAsset>>) => {
          return response.data as PagedData<ComputerAsset>;
      });
  }

  /**
   * @description Returns a paged list of computer leases
   */
  getComputerLeases(filter: ComputerLeasesFilterOptions
    ): Promise<PagedData<ComputerLease>> {
        return BimsHttpService.get(`/computers/leases`, {
            params: filter
        }).then((response: AxiosResponse<PagedData<ComputerLease>>) => {
            return response.data as PagedData<ComputerLease>;
        });
    }

  /**
   * @description Returns the computer asset with the specified id
   */
  getComputerAsset(id: string): Promise<ComputerAsset> {
    return BimsHttpService.get(`/computers/assets/${id}`).then((response: AxiosResponse<ComputerAsset>) => {
      return response.data as ComputerAsset;
      });
  }

  /**
   * @description Returns the computer lease with the specified id
   */
  getComputerLease(id: string): Promise<ComputerLease> {
    return BimsHttpService.get(`/computers/leases/${id}`).then((response: AxiosResponse<ComputerLease>) => {
      return response.data as ComputerLease;
      });
  }

  /**
   * @description Downloads the CSV export of all computer leases
   */
  public getExcelExport(): Promise<any> {
      return BimsHttpService.get(`computers/leases/export`).then(response => {
          return FileProvider.ForceFileDownload(response)
      })
  }

  /**
   *  @description Adds new computer asset
   */
  addComputerAsset(computerAsset: NewComputerAsset): Promise<string> {
    return BimsHttpService.post(`/computers/assets`,
      computerAsset
    ).then(response => {
        return response.data
    });
  }

  /**
   *  @description Adds new computer lease
   */
  addComputerLease(computerLease: NewComputerLease): Promise<string> {
    return BimsHttpService.post(`/computers/leases`,
      computerLease
    ).then(response => {
        return response.data
    });
  }

  /**
   * @description Updates the computer asset
   */
  updateComputerAsset(id: string, computerAsset: UpdateComputerAsset): Promise<any> {
    return BimsHttpService.put(`/computers/assets/${id}`,
      computerAsset
    )
  }

  /**
   * @description Updates the computer lease
   */
  updateComputerLease(id: string, computerLease: UpdateComputerLease): Promise<any> {
    return BimsHttpService.put(`/computers/leases/${id}`,
      computerLease
    )
  }
}

export default new ComputersService();
